import { render, staticRenderFns } from "./precinctBlock.vue?vue&type=template&id=96db89c0&"
import script from "./precinctBlock.vue?vue&type=script&lang=js&"
export * from "./precinctBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports